import AdvancedEditorPreview, {
  AdvancedEditorPreviewProps,
} from './AdvancedEditorPreview';

export { AdvancedEditorPreviewProps };
export default AdvancedEditorPreview;
